import React, { useState } from "react";
// import { FaGoogle, FaVk, FaYandex } from "react-icons/fa";
import { FaYandex } from "react-icons/fa";

import styles from "./SocialAuth.module.css";
import { socialAuthService, SocialProvider } from "@api/socialAuthService";
import { UserData } from "@api/types";

interface SocialAuthProps {
  onAuth: (userData: UserData) => void;
  onError?: (error: string) => void;
}

interface SocialButton {
  provider: SocialProvider;
  label: string;
  icon: React.ReactNode;
  className: string;
}

const socialButtons: SocialButton[] = [
  // {
  //   provider: "google",
  //   label: "Войти через Google",
  //   icon: <FaGoogle className={styles.icon} />,
  //   className: styles.google,
  // },
  {
    provider: "yandex",
    label: "Войти через Яндекс",
    icon: <FaYandex className={styles.icon} />,
    className: styles.yandex,
  },
  // {
  //   provider: "vk",
  //   label: "Войти через ВКонтакте",
  //   icon: <FaVk className={styles.icon} />,
  //   className: styles.vk,
  // },
];

export const SocialAuth: React.FC<SocialAuthProps> = ({ onAuth, onError }) => {
  const [isAuthenticating, setIsAuthenticating] =
    useState<SocialProvider | null>(null);

  const handleAuth = async (provider: SocialProvider) => {
    setIsAuthenticating(provider);

    try {
      const result = await socialAuthService.authenticateWithSocial(provider);

      if (result.success && result.userData) {
        onAuth(result.userData);
      } else if (result.error && onError) {
        onError(result.error);
      }
    } catch (error) {
      if (onError) {
        onError(
          error instanceof Error
            ? error.message
            : "Ошибка при авторизации через соцсеть"
        );
      }
      console.error("Ошибка при авторизации через соцсеть:", error);
    } finally {
      setIsAuthenticating(null);
    }
  };

  return (
    <div className={styles.container}>
      <p className={styles.title}>Войти через соцсети</p>
      <div className={styles.socialButtons}>
        {socialButtons.map(({ provider, label, icon, className }) => (
          <button
            key={provider}
            className={`${styles.socialButton} ${className} ${
              isAuthenticating === provider ? styles.loading : ""
            }`}
            onClick={() => handleAuth(provider)}
            disabled={isAuthenticating !== null}
          >
            {isAuthenticating === provider ? (
              <span className={styles.spinner}></span>
            ) : (
              icon
            )}
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};
